import SliceNames from '@/state/enum';
import { OptionsState } from '@/state/slices/options/typings';
import EntryPointsHelper from '@/utils/entry-points-helper';
import NaasHelper from '@/utils/naas-helper';

EntryPointsHelper.init();

const optionsState: OptionsState = {
	[SliceNames.OPTIONS]: NaasHelper.getEntrypointDataset(),
};

export default optionsState;
